<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element
      class="g-grey-box"
      v-bind="{Data: {icon: ['custom', 'controller-mode'], title: $t('messages.controllerMode.title'), subTitle: computedControllerModeTitle}}"
    >
      <ul>
        <li>
          <controller-mode
            :socket-message = "SocketMessage"
            :controller-mode = "controllerMode"
            :controller-modes="controllerModes"
            @SetPageMessage="SetPageMessage"
          />
        </li>
      </ul>
    </accordion-element>
  </div>
</template>

<script>
import AccordionElement from '@/components/elements/AccordionElement'
import ControllerMode from '@/components/ControllerMode.vue'

export default {
  name: 'AccordionControllerMode',
  components: {
    'accordion-element': AccordionElement,
    'controller-mode': ControllerMode
  }, // Available in this.$options.name
  props: {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    controllerMode: {
      type: Number,
      default: null
    },
    returnControllerMode: {
      type: String,
      default: null
    },
    controllerModes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedControllerModeTitle() {
      let state = (this.controllerMode !== 2) ? 'red' : 'green'
      return `<span class="${state}">${this.returnControllerMode}</span>`
    }
  },
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    }
  }
}
</script>

<style lang="scss">
</style>
